import { ReloadOutlined } from "@ant-design/icons";
import { ButtonProps } from "antd";
import { FC } from "react";

import { StyledHeaderReloadBtn } from "./Styled";

interface HeaderReloadBtnProps extends ButtonProps {}

export const HeaderReloadBtn: FC<HeaderReloadBtnProps> = ({ ...rest }) => {
    return (
        <StyledHeaderReloadBtn
            type="text"
            {...rest}
            icon={<ReloadOutlined />}
        />
    );
};
